// Icon.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory } from '@fortawesome/free-solid-svg-icons'; // Icône pour l'historique

const IconHistory = ({ icon = faHistory, size = '3x', color = '#f5721e' }) => {
  return <FontAwesomeIcon icon={icon} size={size} color={color} />;
};

export default IconHistory;
